/**
 * Task AN: native app navigation (cashier order, owner all-branch dashboard), 配套顾客列表, WhatsApp click-to-send.
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["an.nav.pkgCustomers","Package clients","配套顾客"],
  ["an.nav.pkgCustomersLong","Package customer list","配套顾客列表"],
  ["an.nav.subs","Subscribers","订阅顾客"],
  ["an.nav.subsLong","Subscription customer list","订阅顾客列表"],
  ["an.nav.dailyClose","Daily close (cash drawer)","日结（钱箱）"],
  ["an.nav.hqHome","Home","首页"],
  ["an.nav.hqStaff","Staff","员工"],
  ["an.nav.hqStock","Stock","库存"],
  ["an.nav.hqClaims","Claims","报销"],
  ["an.nav.hqLeave","Leave","请假"],
  ["an.mode.toStore","Switch to cashier mode","切换到收银模式"],
  ["an.mode.toOwner","Back to owner view","返回老板视图"],
  ["an.allBranches","All branches","全部分店"],
  ["an.pkg.title","Package customers","配套顾客列表"],
  ["an.pkg.sub","Customers with an active package: sessions left, expiry and last visit.","有有效配套的顾客：剩余次数、到期日和最近到店。"],
  ["an.pkg.search","Search name, phone or package","搜索姓名、电话或配套"],
  ["an.pkg.sort.expiry","Expiring first","最先到期"],
  ["an.pkg.sort.remaining","Fewest sessions left","剩余次数最少"],
  ["an.pkg.sort.visit","Last visit","最近到店"],
  ["an.pkg.sort.name","Name","姓名"],
  ["an.pkg.left","{n} left","剩 {n} 次"],
  ["an.pkg.leftOf","{n} / {total} left","剩 {n} / {total} 次"],
  ["an.pkg.expires","Expires {date}","{date} 到期"],
  ["an.pkg.noExpiry","No expiry","无到期日"],
  ["an.pkg.lastVisit","Last visit {date}","最近到店 {date}"],
  ["an.pkg.never","No visit yet","尚未到店"],
  ["an.pkg.frozen","Frozen","已冻结"],
  ["an.pkg.empty","No customer has an active package","目前没有顾客持有有效配套"],
  ["an.pkg.redeem","Redeem","核销"],
  ["an.pkg.profile","Customer profile","顾客资料"],
  ["an.pkg.count","{n} customers","{n} 位顾客"],
  ["an.pkg.expSoon","Expires in {days} days","{days} 天后到期"],
  ["an.subs.title","Subscription customers","订阅顾客列表"],
  ["an.hq.title","All branches","全部分店"],
  ["an.hq.today","Today","今天"],
  ["an.hq.month","This month","本月"],
  ["an.hq.sales","Sales","营业额"],
  ["an.hq.orders","{n} sales","{n} 笔"],
  ["an.hq.received","Received","实收"],
  ["an.hq.debtNew","New debt","新增欠款"],
  ["an.hq.debtCollected","Debt collected","收回欠款"],
  ["an.hq.debtOut","Outstanding debt","未收欠款"],
  ["an.hq.bookings","Bookings","预约"],
  ["an.hq.topServices","Top services","热门服务"],
  ["an.hq.branches","Branches","分店"],
  ["an.hq.open","Open","营业中"],
  ["an.hq.closed","Closed","已结束营业"],
  ["an.hq.openSince","Open since {time}","{time} 开始营业"],
  ["an.hq.cashUpDone","Cash-up done","已日结"],
  ["an.hq.cashUpPending","Cash-up not done","未日结"],
  ["an.hq.variance","Last drawer difference {amount}","上次钱箱差额 {amount}"],
  ["an.hq.openCount","{open} of {n} open","{n} 间中 {open} 间营业中"],
  ["an.hq.ownerOnly","Only the owner sees the all-branch dashboard.","只有老板可以查看全部分店总览。"],
  ["an.staff.title","Staff performance","员工业绩"],
  ["an.staff.commission","Commission","提成"],
  ["an.staff.services","Services","服务"],
  ["an.staff.customers","Customers","顾客"],
  ["an.staff.rebooking","Rebooking","回头预约"],
  ["an.staff.attendance","Attendance","出勤"],
  ["an.staff.daysHours","{days} days · {hours} h","{days} 天 · {hours} 小时"],
  ["an.staff.empty","No staff activity in this period","这段期间没有员工业绩"],
  ["an.period.today","Today","今天"],
  ["an.period.this_week","This week","本周"],
  ["an.period.this_month","This month","本月"],
  ["an.period.last_month","Last month","上月"],
  ["an.stock.title","Stock & suppliers","库存与供应商"],
  ["an.stock.value","Stock value","库存价值"],
  ["an.stock.items","{n} items","{n} 项"],
  ["an.stock.low","Low stock","低库存"],
  ["an.stock.lowN","{n} low","{n} 项低库存"],
  ["an.stock.lowLine","{qty} {unit} left · reorder at {point}","剩 {qty} {unit} · 补货点 {point}"],
  ["an.stock.search","Search items","搜索商品"],
  ["an.stock.allItems","Items","商品"],
  ["an.stock.payables","Owed to suppliers","应付供应商"],
  ["an.stock.overdue","{amount} overdue","逾期 {amount}"],
  ["an.stock.nextDue","Next due {date}","下次到期 {date}"],
  ["an.stock.awaiting","Purchase orders awaiting delivery","待到货采购单"],
  ["an.stock.expected","Expected {date}","预计 {date} 到货"],
  ["an.stock.noDate","No delivery date","未定到货日"],
  ["an.stock.late","Late","已逾期"],
  ["an.stock.linesN","{n} lines","{n} 项"],
  ["an.stock.received","{got} / {ordered} received","已到 {got} / {ordered}"],
  ["an.stock.noInventory","Inventory is not part of this shop's plan.","此店的方案不含库存功能。"],
  ["an.stock.noSuppliers","Suppliers & purchase orders need the Supplier system add-on.","供应商与采购单需要供应商系统附加功能。"],
  ["an.stock.none","Nothing here","暂无"],
  ["an.stock.movements","Recent movements","最近变动"],
  ["an.stock.perBranch","By branch","各分店"],
  ["an.claims.title","Expense claims","报销申请"],
  ["an.leave.title","Leave requests","请假申请"],
  ["an.wa.send","Send with WhatsApp","用 WhatsApp 发送"],
  ["an.wa.short","WhatsApp","WhatsApp"],
  ["an.wa.noPhone","No phone number on file — choose the chat in WhatsApp.","顾客没有手机号 — 请在 WhatsApp 中选择联系人。"],
  ["an.wa.reminder","Send reminder with WhatsApp","用 WhatsApp 发提醒"],
  ["an.wa.receipt","Send receipt with WhatsApp","用 WhatsApp 发收据"],
  ["an.wa.debt","Debt reminder with WhatsApp","用 WhatsApp 发欠款提醒"],
  ["an.wa.payLink","Pay link with WhatsApp","用 WhatsApp 发付款链接"],
  ["an.wa.referral","Share with WhatsApp","用 WhatsApp 分享"],
] as const;

export type AnKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<AnKey, string>;

export const taskAN = { en: col(1), zh: col(2), ms: col(1) };
